export const projectSettingsRoute = `/project-settings`;
export const projectCustomisationRoute = `${projectSettingsRoute}/project-customisation`;
export const projectRolePermissionsRoute = `${projectSettingsRoute}/project-role-permissions`;
export const projectScheduleConfigRoute = `${projectSettingsRoute}/project-schedule-config`;
export const projectAttributesRoute = `${projectSettingsRoute}/project-attributes`;
export const sitemapsRoute = `${projectSettingsRoute}/sitemaps`;
export const billingRoute = `${projectSettingsRoute}/billing`;
export const ssoRoute = `${projectSettingsRoute}/sso-config`;
export const projectLayerTemplatesRoute = `${projectSettingsRoute}/layer-templates`;
